import OnestockInfoContainer from "./OnestockInfoContainer";
import OnestockInfoStore from "./OnestockInfoStore";

export default OnestockInfoStore(OnestockInfoContainer);